export default class Image {
	constructor({
		id,
		name,
		url,
		size,
	} = {}) {
		this._id = id;
		this._name = name;
		this._url = url;
		this._size = size;
	}

	getId() {
		return this._id;
	}

	getKey() {
		return String(this._id);
	}

	getName() {
		return this._name;
	}

	getURL() {
		return this._url;
	}

	getSize() {
		return this._size;
	}

	getKoSize() {
		return Math.round(this._size/1000);
	}
}
